import { useContext, useLayoutEffect, useRef } from "react";
import { Check } from "@aidron/aidron-ds";
import { TenantContext } from "../../../../templates/context/TenantContext";
import PropTypes from 'prop-types';

export function CheckCell({ actions, ctx, uiState }) {

  const { hierarchy } = useContext(TenantContext);

  const { setCheckColumnWidth = () => {}, setCheckedProducts } = actions || {};

  const { 
    productId, 
    checkedProducts, 
    productIds,
    selectedHierarchyIndexes
  } = ctx || {};

  const { 
    individualProductCheck,
    freezeColumns,
    headerHeight
  } = uiState || {};

  const checkColumn = useRef(null);

  const areAllIdsInCheckedProducts = () => {
    if (!productIds?.length) return false;
    if (checkedProducts.length !== productIds.length) return false;
    return checkedProducts.every(productId => productIds.includes(productId));
  }

  const defineCheckValue = () => {
    if (individualProductCheck) return checkedProducts.includes(productId) ? "1" : "0";
    else return areAllIdsInCheckedProducts() ? "1" : "0";
  }

  const value = defineCheckValue();

  const handleAllChecks = (e) => {
    if (e === "0") {
      setCheckedProducts(productIds);
    } else {
      setCheckedProducts([]);
    }
  }

  const handleIndividualCheck = (e) => {
    if (e === "0") {
      setCheckedProducts(prevState => [productId, ...prevState]);
    } else {
      const index = checkedProducts.indexOf(productId);
      checkedProducts.splice(index, 1);
      setCheckedProducts([...checkedProducts]);
    }
  }

  const defineRightBorderFade = () => {
    if (defineHierarchyToDisplay().length === 0 && freezeColumns) {
      if (individualProductCheck) return "right-border-fade";
      else return "right-border-fade-with-background-color";
    }
    return "";
  };

  const defineHierarchyToDisplay = () => hierarchy.levels.filter((level, index) => selectedHierarchyIndexes?.includes(index));

  useLayoutEffect(() => {
    if (!individualProductCheck) return;

    const node = checkColumn.current;
    if (!node) return;

    const updateWidth = () => {
      setCheckColumnWidth(node.getBoundingClientRect().width);
    };

    updateWidth();

    const observer = new ResizeObserver(updateWidth);
    observer.observe(node);

    return () => observer.disconnect();
  }, [individualProductCheck]);

  return (
    <th
      ref={checkColumn}
      className={`background-color-white vertical-align-middle padding-sides-030rem z-4 ${
        freezeColumns ? "position-sticky" : ""  // ← remove o start-0
      } ${defineRightBorderFade()} ${individualProductCheck ? "" : "z-5 cell-bottom-border"}`}
      style={{
        top: individualProductCheck ? "" : `${headerHeight}px`,
        left: freezeColumns ? "0px" : "",  // ← controla via style inline
      }}>
      <Check
        two
        handleChange={e => {
          if (individualProductCheck) handleIndividualCheck(e);
          else handleAllChecks(e);
        }}
        value={value}/>
    </th>
  );
  
};

CheckCell.propTypes = {
  actions: PropTypes.shape(),
  ctx: PropTypes.shape(),
  uiState: PropTypes.shape()
}